import request from "./../utils/request";

export function getOfflineSupportRequests({
    perPage = 25,
    page = 1,
    startDate = null,
    endDate = null,
    query = null,
    userId = null,
    point = 0,
}) {
    const qs = {
        perPage: perPage,
        pageCount: page,
        dateBegin: startDate,
        dateEnd: endDate,
        query: query,
        userId: userId,
        point: point,
    };

    Object.keys(qs).forEach((key) => {
        if (!qs[key]) {
            delete qs[key];
        }
    });

    return request.get("/offlineSupportRequests/pagination", {
        params: qs,
    });
}

export function getWaitingOfflineSupportRequests({ perPage = 25, page = 1 }) {
    const qs = {
        perPage: perPage,
        pageCount: page,
    };

    Object.keys(qs).forEach((key) => {
        if (!qs[key]) {
            delete qs[key];
        }
    });

    return request.get("/offlineSupportRequests/waiting/pagination", {
        params: qs,
    });
}

export function getOfflineSupportRequest(id) {
    return request.get(`/offlineSupportRequests/${id}`);
}

export function sendResponse(id, data) {
    return request.post(`/offlineSupportRequests/${id}/sendResponse`, data);
}

export function deleteOfflineSupportRequest(id) {
    return request.delete(`/offlineSupportRequests/${id}`);
}
